//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "SearchBar",
  data: function data() {
    return {
      searchBy: ['Nric/Fin', 'Company', 'Full Name'],
      searchBy2: ['Nric/Fin'],
      searchPlaceholder: 'Please Choose Search By',
      searchContent: '',
      searchKey: ''
    };
  },

  methods: {
    searchIt: function searchIt() {
      console.log('searchBy: [Nric/Fin, Company, Full Name] original');
      console.log('\n\n ======== From Search Bar ======== \n Search Key: ', this.searchKey, '\n Search Content:', this.searchContent, '\n =========== ');

      if (!!this.searchKey && !!this.searchContent) {
        this.$emit('searchPendingApproval', {
          searchKey: this.searchKey,
          searchContent: this.searchContent.toUpperCase()
        });

        this.$emit('searchUser', {
          searchKey: this.searchKey,
          searchContent: this.searchContent.toUpperCase()
        });

        console.log('\n\n ====== Search Info emitted ======\n');
        this.searchKey = '';
        this.searchContent = '';
      } else {
        alert(' - Please Select Proper Search-By Option \n \t\tOr \n - Key In Proper Search Content');
      }
    },
    changeSearchKey: function changeSearchKey(item, selection) {
      this.searchKey = item;
      this.searchPlaceholder = 'Search By ' + item;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/dashboard/SearchBar.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/dashboard/SearchBar.vue
// module chunks = 0 1 2 4 5